import React from "react";
import styled from "styled-components";
import 'swiper/swiper-bundle.min.css';
import Xko from "../../assets/img/zavritW.svg";


const ModalInner = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 100000;

  .modalBox {
    background: white;
    width: calc(100% - 50px);

    max-width: 600px;

    ${props => props.isWide && `
      max-width: 1150px;
    `}

    border-radius: 5px;
    margin: 0 auto;
    margin-top: 100px;
    max-height: calc(100vh - 200px);
    overflow: hidden;
    box-shadow: 0 3px 15px 0 rgba(0,0,0,0.13);

    @media (max-width: 1000px) {
      margin-top: 50px;
      max-height: calc(100vh - 100px);
    }

    @media (max-width: 580px) {
      width: calc(100% - 20px);
      margin-top: 10px;
      max-height: calc(100vh - 20px);
    }

    .modalTop {
      background: #566FEF;
      position: relative;
      padding: 15px;

      h2 {
        color: #fff;
        font-family: Visuelt-Medium;
        font-size: 18px;
        width: calc(100% - 30px);
      }

      button {
        background: 0;
        border: 0;
        padding: 0;
        position: absolute;
        top: 16px;
        right: 15px;
        cursor: pointer;

        img {
          width: 20px;
          height: 20px;
        }
      }
    }

    .modalBot {
      min-height: 100px;
      padding: 30px 0;
      overflow: scroll;
      max-height: calc(100vh - 280px - 30px);

      @media (max-width: 1000px) {
        max-height: calc(100vh - 220px);
      }

      @media (max-width: 580px) {
        max-height: calc(100vh - 100px - 30px);
      }

      form {
        width: calc(100% - 24px - 60px);
        margin-left: 30px;

        @media (max-width: 580px) {
          margin-left: 15px;
          width: calc(100% - 24px - 30px);
        }

        .formInner {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;

          @media (max-width: 580px) {
            display: block;
          }

          .pole {
            width: calc(50% - 20px);

            @media (max-width: 580px) {
              width: calc(100%);
            }
          }
          
          .react-datepicker-wrapper {
            width: 100%;
          }
        }

        .errorMsgPrvni {
          font-family: Visuelt-Regular;
          line-height: 25px;
          font-size: 16px;
          color: #FF6060;
          margin: 0;
          margin-top: 20px;
        }

        .buttons {
          display: block;
          margin-top: 30px;

          .submit {
            font-family: Visuelt-Medium;
            font-size: 16px;
            color: #FFFFFF;
            text-align: center;
            background: #566FEF;
            border: 0;
            padding: 10px 0;
            width: 120px;
            border-radius: 5px;

            &:hover {
              cursor: pointer;
              background: #4158cc;
            }
          }

          .zpet {
            font-family: Visuelt-Medium;
            font-size: 16px;
            color: #000;
            background: #efefef;
            text-align: center;
            border: 0;
            padding: 10px 0;
            width: 120px;
            border-radius: 5px;
            margin-left: 20px;

            &:hover {
              cursor: pointer;
            }
          }
        }

        label {
          display: block;
          margin-bottom: 20px;

          span {
            display: block;
            font-family: Visuelt-Regular;
            font-size: 16px;
            color: #6C6C6C;
            line-height: 25px;
            margin-bottom: 8px;
          }

          input {
            display: block;
            width: 100%;
            background: #FFFFFF;
            border: 2px solid #D2D2D2;
            border-radius: 5px;
            padding: 10px;
            font-family: Visuelt-Regular;
            font-size: 16px;
            color: #000;
            line-height: 25px;

            &:focus {
              border: 2px solid #566FEF;
            }
          }

          textarea {
            display: block;
            width: 100%;
            background: #FFFFFF;
            border: 2px solid #D2D2D2;
            border-radius: 5px;
            padding: 10px;
            font-family: Visuelt-Regular;
            font-size: 16px;
            color: #000;
            line-height: 25px;
            resize: none;
            height: 100px;

            &:focus {
              border: 2px solid #566FEF;
            }
          }

          .errorMsg {
            font-family: Visuelt-Regular;
            line-height: 25px;
            font-size: 16px;
            color: #FF6060;
            margin: 0;
            margin-top: 8px;
          }
        }

        .inputError {
          input {
            border: 2px solid #FF6060 !important;
          }

          span {
            color: #FF6060;
          }
        }
      }
    }
  }
`;

const ParteModal = ({ children, setIsVisible, heading, isWide }) => {
 

  return (
    <ModalInner isWide={isWide}>
      <div className="modalBox">
        <div className="modalTop">
          <h2>{heading}</h2>
          <button onClick={() => setIsVisible(false)}>
            <img src={Xko} alt="Zavřít" />
          </button>
        </div>
        <div className="modalBot">
          {children}
        </div>
      </div>
    </ModalInner>
  );
}

export default ParteModal;
